"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicColumnConfigProvider = void 0;
exports.defineColumnHandler = defineColumnHandler;
const react_1 = __importDefault(require("react"));
function defineColumnHandler(handlerDef) {
    return handlerDef;
}
const defaultHandlers = [
    defineColumnHandler({
        name: 'string',
        label: 'String',
        columnType: 'string',
        arrayColumnType: 'string-array',
        format: (columnValue) => columnValue,
        formatArray: (columnValue) => columnValue?.join('; '),
    }),
    defineColumnHandler({
        name: 'number',
        label: 'Number',
        columnType: 'number',
        arrayColumnType: 'number-array',
        format: (columnValue) => columnValue,
        formatArray: (columnValue) => columnValue?.join('; '),
    }),
    defineColumnHandler({
        name: 'boolean',
        label: 'Boolean',
        columnType: 'boolean',
        format: (columnValue) => (typeof columnValue === 'boolean' ? (columnValue ? 'Yes' : 'No') : undefined),
    }),
    defineColumnHandler({
        name: 'date',
        label: 'Date',
        columnType: 'number',
        arrayColumnType: 'number-array',
        format: (columnValue) => (columnValue ? new Date(columnValue).toLocaleDateString() : undefined),
        formatArray: (columnValue) => columnValue?.map((val) => new Date(val).toLocaleDateString()).join('; '),
    }),
];
const DynamicColumnConfigContext = react_1.default.createContext({});
const DynamicColumnConfigProvider = ({ children, ...props }) => {
    let handlers = defaultHandlers;
    if (typeof props.columnHandlers === 'function') {
        handlers = props.columnHandlers(defaultHandlers);
    }
    else if (Array.isArray(props.columnHandlers)) {
        handlers = props.columnHandlers;
    }
    const ctxValue = {
        columnHandlers: handlers,
    };
    return react_1.default.createElement(DynamicColumnConfigContext.Provider, { value: ctxValue }, children);
};
exports.DynamicColumnConfigProvider = DynamicColumnConfigProvider;
exports.default = DynamicColumnConfigContext;
